import { React } from "react";
import { Link } from "react-router-dom";
import { AppBar, Typography, Button, Toolbar, Avatar } from "@material-ui/core";
import useStyles from "./styles.js";

const Navbar = () => {
    const classes = useStyles();
    const routeChange = () => {
        window.scrollTo(0, 0);
    };

    return (
        <AppBar className={classes.appBar} position="sticky" color="inherit" fullWidth>
            <div className={classes.brandContainer}>
                <Typography
                    component={Link}
                    to="/"
                    className={classes.heading}
                    variant="h4"
                    align="center"
                    onClick={routeChange}
                >
                    TEAM QCRYPT
                </Typography>
            </div>
            <Toolbar className={classes.toolbar}>
                <Typography component={Link} to="/" className={classes.pages} onClick={routeChange}>
                    Home
                </Typography>

                <Typography
                    component={Link}
                    to="/research"
                    className={classes.pages}
                    onClick={routeChange}
                >
                    Research
                </Typography>

                <Typography
                    component={Link}
                    to="/contact-us"
                    className={classes.pages}
                    onClick={routeChange}
                >
                    Contact Us
                </Typography>
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;
